import { render, staticRenderFns } from "./tableManagement.vue?vue&type=template&id=95f50ec4&scoped=true&"
import script from "./tableManagement.vue?vue&type=script&lang=js&"
export * from "./tableManagement.vue?vue&type=script&lang=js&"
import style0 from "./tableManagement.vue?vue&type=style&index=0&lang=css&"
import style1 from "./tableManagement.vue?vue&type=style&index=1&id=95f50ec4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95f50ec4",
  null
  
)

export default component.exports